"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var transformSchema_1 = require("./transformSchema");
exports.transformSchema = transformSchema_1.default;
var AddArgumentsAsVariables_1 = require("./AddArgumentsAsVariables");
exports.AddArgumentsAsVariables = AddArgumentsAsVariables_1.default;
var CheckResultAndHandleErrors_1 = require("./CheckResultAndHandleErrors");
exports.CheckResultAndHandleErrors = CheckResultAndHandleErrors_1.default;
var ReplaceFieldWithFragment_1 = require("./ReplaceFieldWithFragment");
exports.ReplaceFieldWithFragment = ReplaceFieldWithFragment_1.default;
var AddTypenameToAbstract_1 = require("./AddTypenameToAbstract");
exports.AddTypenameToAbstract = AddTypenameToAbstract_1.default;
var FilterToSchema_1 = require("./FilterToSchema");
exports.FilterToSchema = FilterToSchema_1.default;
var RenameTypes_1 = require("./RenameTypes");
exports.RenameTypes = RenameTypes_1.default;
var FilterTypes_1 = require("./FilterTypes");
exports.FilterTypes = FilterTypes_1.default;
var TransformRootFields_1 = require("./TransformRootFields");
exports.TransformRootFields = TransformRootFields_1.default;
var RenameRootFields_1 = require("./RenameRootFields");
exports.RenameRootFields = RenameRootFields_1.default;
var FilterRootFields_1 = require("./FilterRootFields");
exports.FilterRootFields = FilterRootFields_1.default;
var ExpandAbstractTypes_1 = require("./ExpandAbstractTypes");
exports.ExpandAbstractTypes = ExpandAbstractTypes_1.default;
var ExtractField_1 = require("./ExtractField");
exports.ExtractField = ExtractField_1.default;
var WrapQuery_1 = require("./WrapQuery");
exports.WrapQuery = WrapQuery_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql-tools/dist/transforms/index.js
// module id = 418
// module chunks = 1